export interface Vector2 {
  x: number;
  y: number;
}

export interface PlatformData {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface GoalData {
  x: number;
  y: number;
}

export interface LevelData {
  id: string;
  name: string;
  width: number;
  height: number;
  playerStart: Vector2;
  platforms: PlatformData[];
  coins: Vector2[];
  goal: GoalData;
}

// Shared integer simulation constants used by the rollback sim.
export const PHYSICS = {
  GRAVITY: 1,
  GRAVITY_ASCENT_TICK_INTERVAL: 4,
  GRAVITY_DESCENT_TICK_INTERVAL: 3,
  TERMINAL_VELOCITY: 7,
  PLAYER_SPEED: 2,
  PLAYER_JUMP_FORCE: -11,
  JETPACK_MAX_FUEL: 120,
  JETPACK_THRUST_FORCE: 1,
  JETPACK_THRUST_TICK_INTERVAL: 2,
  JETPACK_MAX_ASCENT_SPEED: -6,
  JETPACK_FUEL_REGEN_TICK_INTERVAL: 2,
  COYOTE_TIME: 96,
  JUMP_BUFFER_TIME: 96,
} as const;

export const COMBAT = {
  PLAYER_MAX_HEALTH: 3,
  LASER_DAMAGE: 1,
  LASER_SPEED: 14,
  LASER_WIDTH: 12,
  LASER_HEIGHT: 4,
  LASER_COOLDOWN_TICKS: 30,
  LASER_LIFETIME_TICKS: 50,
} as const;
